/** Client-side session helpers (httpOnly cookies remain primary for JWT refresh). */

export const REFRESH_FALLBACK_KEY = "thrillion_refresh_session";

/** Public marketing site pages — no login required. */
export const PUBLIC_MARKETING_PATHS = [
  "/",
  "/why-us",
  "/features",
  "/pricing",
  "/contact",
];

/** Auth form pages where guests may browse without a session. */
export const PUBLIC_AUTH_FORM_PATHS = [
  "/login",
  "/schools-login",
  "/forgot-password",
  "/reset-password",
];

export function persistRefreshTokenFallback(refresh) {
  if (!refresh || typeof sessionStorage === "undefined") return;
  try {
    sessionStorage.setItem(REFRESH_FALLBACK_KEY, String(refresh));
  } catch {
    /* ignore quota / private mode */
  }
}

export function getRefreshTokenFallback() {
  if (typeof sessionStorage === "undefined") return null;
  try {
    return sessionStorage.getItem(REFRESH_FALLBACK_KEY);
  } catch {
    return null;
  }
}

export function clearAuthSessionClientState() {
  try {
    localStorage.clear();
    if (typeof sessionStorage !== "undefined") {
      sessionStorage.removeItem(REFRESH_FALLBACK_KEY);
    }
  } catch {
    /* ignore */
  }
}

function normalizePathname(pathname) {
  const raw =
    pathname ||
    (typeof window !== "undefined" ? window.location.pathname : "") ||
    "";
  const p = String(raw).split("?")[0].split("#")[0];
  if (!p || p === "/") return "/";
  return p.length > 1 && p.endsWith("/") ? p.slice(0, -1) : p;
}

export function isPublicMarketingPath(pathname) {
  const p = normalizePathname(pathname);
  return PUBLIC_MARKETING_PATHS.includes(p);
}

/**
 * Paths where missing/expired auth must NOT hard-redirect to /login.
 * Includes marketing site + auth forms.
 */
export function isPublicAuthPath(pathname) {
  const p = normalizePathname(pathname);
  if (isPublicMarketingPath(p)) return true;
  return PUBLIC_AUTH_FORM_PATHS.some(
    (segment) => p === segment || p.startsWith(`${segment}/`)
  );
}
